// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  api_url: 'https://bontub-api.myplgs.com/v1',
  google_maps_api_key: 'AIzaSyBjvKVsQUKZvYsj4OBhp01TGSConmou94o',
  telegram_bot_url: 'https://t.me/bontub_dev_bot',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
